// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"ProjectsPage_cardContainer__30Q08","filter_form":"ProjectsPage_filter_form__14OAC","filter_select":"ProjectsPage_filter_select__1eWkz"};